import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

export const SpeechBubble: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <SVG width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
    <Path
      d='M8.02499 1C3.584 1 0.0187046 3.9375 0.0187046 7.5C0.0187046 9.0625 0.67547 10.4688 1.77008 11.5938C1.39478 13.1875 0.0812537 14.5625 0.0812537 14.5938C-0.01257 14.6562 -0.01257 14.7812 0.0187046 14.875C0.0499791 14.9688 0.143803 15 0.268901 15C2.33302 15 3.86547 14.0312 4.64734 13.4062C5.6794 13.7812 6.80528 14 8.02499 14C12.4347 14 16 11.0938 16 7.5C16 3.9375 12.4347 1 8.02499 1Z'
      fill='currentColor'
    />
  </SVG>
);
